export const keepLastResolvedEvent = (previousEvent, incomingEvent) => {
  if (incomingEvent?.id) return incomingEvent;
  return previousEvent ?? null;
};
